import type { SelectSize } from './selectTypes';

/**
 * Size styles
 */
export const sizeStyles: Record<SelectSize, { trigger: string; label: string; option: string }> = {
  sm: {
    trigger: 'px-3.5 py-2 text-sm rounded-lg',
    label: 'text-xs mb-1.5',
    option: 'px-3.5 py-2 text-sm',
  },
  md: {
    trigger: 'px-4 py-3 text-base rounded-xl',
    label: 'text-sm mb-2',
    option: 'px-4 py-2.5 text-base',
  },
  lg: {
    trigger: 'px-5 py-3.5 text-lg rounded-2xl',
    label: 'text-base mb-2.5',
    option: 'px-5 py-3 text-lg',
  },
};

/**
 * Dropdown animation variants
 */
export const dropdownVariants = {
  hidden: {
    opacity: 0,
    y: -8,
    scale: 0.95,
    transition: { duration: 0.15 },
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring' as const,
      stiffness: 300,
      damping: 25,
    },
  },
  exit: {
    opacity: 0,
    y: -8,
    scale: 0.95,
    transition: { duration: 0.15 },
  },
};
